import { Link, Stack, Typography } from "@mui/material";

import { FieldDrift } from "./wasteActivitySelections";

/**
 * Helper context rendered under each Waste Activity field: the live
 * recommendation (with an inline "Use recommendation" accept affordance when
 * the chosen value differs and the field is editable), plus the subtle
 * override/drift captions from the design doc. Captions only — no chips or
 * dialogs — so it slots under any field layout. `readOnly` keeps the captions
 * but drops the accept affordance, so read-only fields still show their
 * recommendation context.
 */
export function RecommendationHint({
  recommendationText,
  drift,
  onAccept,
  readOnly,
}: {
  /** Display text of the live recommendation; null when there is none. */
  recommendationText: string | null;
  drift: FieldDrift;
  /** Sets the field back to the live recommendation. */
  onAccept: () => void;
  readOnly: boolean;
}) {
  return (
    <Stack spacing={0}>
      <Typography variant="caption" color="text.secondary">
        Recommended: {recommendationText ?? "—"}
        {!readOnly && drift.overridden && recommendationText != null && (
          <>
            {" · "}
            <Link component="button" type="button" variant="caption" onClick={onAccept}>
              Use recommendation
            </Link>
          </>
        )}
      </Typography>
      {drift.overridden && (
        <Typography variant="caption" color="warning.main">
          Differs from recommendation
        </Typography>
      )}
      {drift.recommendationChanged && (
        <Typography variant="caption" color="warning.main">
          Recommendation has changed since last save
        </Typography>
      )}
    </Stack>
  );
}
